export default {
  navStyle: {
    // position: `absolute`,
    // width: `100%`,
    // top: '0',
    // bottom: '30px',
    // minHeight: `calc(100% - 5rem)`,
    overflowY: 'scroll',
    backgroundColor: '#fff',
    padding: '0 0 4rem',
    borderRight: '1px solid #e5e5e5',
  },

  buttonStyle: {
    margin: '0 2.6rem 1em',
    padding: '0 2.5rem',
    backgroundColor: '#2a72a5',
  },

  navGroupHeader: {
    padding: '0.7rem 2.5rem 0.3rem',
    fontWeight: 'bold',
    fontSize: '0.85em',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },

  navItemStyle: {
    display: 'flex',
    color: 'rgb(95, 95, 95)',
    cursor: 'pointer',
  },

  navItemBorderStyle: {
    width: '0.4rem',
  },

  navItemMainStyle: {
    padding: '0.5rem 1.8rem',
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.9em',
  },

  navItemIconStyle: {
    paddingRight: '0.7rem',
    fontSize: '1.3rem',
  },

  smallIcon: {
    fontSize: '1.4em',
  },

  navFilterItemStyle: {
    padding: '0.25rem 1.54rem 0 3.3rem',
    fontSize: '0.8em',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },

  alertCountStyle: {
    background: '#BB0E3D',
    color: 'white',
    height: '1rem',
    padding: '0 0.3rem',
    borderRadius: '0.3rem',
    fontSize: '0.75em',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transform: 'translate(40%, -5%)',
    marginLeft: 'auto',
  },
};
